
import { Component, Vue } from 'vue-property-decorator';
import {
  getAuthSer,
  setAuthSerDetail,
  deleteAuthCusDetail,
  batchQrCode } from '@/api/device';
import { UserModule } from '@/store/modules/user';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import dialogDeviceDetail from './components/DeviceDetail.vue';
import dialogDeviceRecord from './components/DeviceRecord.vue';
import { parseTime } from '@/utils';
import { checkPermissionUseAndCompany } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import searchForm from "./components/DeviceSearch.vue";

@Component({
  name: 'DeviceTome',
  components: {
    dialogImgLarge,
    dialogDeviceDetail,
    dialogDeviceRecord,
    searchForm
  }
})
export default class extends Vue {
  private checkAll = false;
  private isIndeterminate: any = null;
  private selectedbox = []

  private servicerOptions = []
  private pagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  private deviceSearch: any = {}
  private tableData: any = []
  private dialogDeviceDetailVisible = false;
  private rowData = {};
  private deviceDetail = {};
  private dialogDeviceRecordVisible = false;

  private dialogDeviceEditVisible = false
  private formEdit:any = {
    company_name: '',
    warranty_start_time: '',
    warranty_start_time_loc: '',
    warranty_period: '',
    auth_id: '',
    device_id: ''
  }
  private listLoading = false;
  private isShowDeviceHistry=false
  created() {
    this.isShowDeviceHistry = checkPermissionUseAndCompany(UserModule.getCompanyId, Type.DeviceHistry);
    this.getAuthSer();
  }
  private getAuthSer() {
    this.selectedbox = [];
    this.isIndeterminate = false;
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      ...this.deviceSearch
    };
    getAuthSer(params)
      .then((res) => {
        this.listLoading = false;
        const data = res.data;
        if (data) {
          this.tableData = res.data.list;
          this.pagination.currentPage = parseInt(data.page_current);
          this.pagination.total = parseInt(data.count);
        } else {
          this.pagination.total = 0;
          this.tableData = [];
        }
      })
      .catch((err) => {
        this.pagination.total = 0;
        this.tableData = [];
        let msg = err.msg;
        this.listLoading = false;
      });
  }
  deviceSearchHandle(val: any) {
    this.deviceSearch = val;
    if (val) {
      this.getAuthSer()
    }
  }
  handleCheckAllChange(val: boolean) {
    this.selectedbox = val ? this.tableData : [];
    this.isIndeterminate = false;
  }
  handleSelectionChange(value: any) {
    let checkedCount = value.length;
    this.checkAll = checkedCount === this.tableData.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.tableData.length;
  }
  handlePageSizeChange(val: number) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = val;
    this.getAuthSer();
  }
  handleCurrentChange(val: number) {
    this.pagination.currentPage = val;
    this.getAuthSer();
  }
  detailHandle(val:any) {
    (this.deviceDetail as any).device_id = val.id;
    this.dialogDeviceDetailVisible = true;
  }
  closeDetailHandle(value: boolean) {
    this.dialogDeviceDetailVisible = value;
    this.deviceDetail = {};
  }

  editHandle(val:any) {
    this.dialogDeviceEditVisible = true;
    this.formEdit = {
      company_name: val.company_name,
      warranty_start_time: '',
      warranty_period: val.warranty_period,
      auth_id: val.auth_id,
      device_id: val.id
    };
    this.$set(this.formEdit, 'warranty_start_time_loc', new Date(val.warranty_start_time));
  }

  editDeviceSave() {
    this.dialogDeviceEditVisible = false;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      auth_id: this.formEdit.auth_id,
      device_id: this.formEdit.device_id,
      warranty_start_time: parseTime(this.formEdit.warranty_start_time_loc, '{y}-{m}-{d}'),
      warranty_period: this.formEdit.warranty_period
    };
    setAuthSerDetail(params)
      .then((res) => {
        this.getAuthSer();
        this.showSuccessMsg('修改成功');
      })
      .catch((err) => {
        let msg = err.msg;
      });
  }

  deviceHistory(val:any) {
    this.dialogDeviceRecordVisible = true;
    (this.rowData as any).device_id = val.id;
  }
  closeRecordHandle() {
    this.dialogDeviceRecordVisible = false;
    this.rowData = {};
  }

  canel(val:any) {
    this.$confirm('确认取消授权吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          id: val.auth_id,
          device_id: val.id
        };
        deleteAuthCusDetail(params)
          .then((res) => {
            this.getAuthSer();
            this.showSuccessMsg('取消成功');
          })
          .catch((err) => {
            let msg = err.msg;
          });
      })
      .catch(() => {});
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private improtQr() {
    if (!this.selectedbox || this.selectedbox.length < 1) {
      this.$notify.warning({
        title: '提示',
        message: '请选择设备'
      });
      return;
    }
    let id = '';
    for (var item of this.selectedbox) {
      id = id + (item as any).id + ',';
    }
    let params:any = {};
    params.company_id = UserModule.getCompanyId;
    params.user_id = UserModule.getUserId;
    params.id = id.substring(0, id.length - 1);
    batchQrCode(params).then(res => {
    }).catch(err => {
      if (!err.msg) {
        let blob = new Blob([err]);
        let fileName = new Date().getTime() + '.pdf';
        if ('download' in document.createElement('a')) {
          // 非IE下载
          let elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          // navigator.msSaveBlob(blob, fileName);
        }
        this.$message.success('下载文件成功');
      } else {
        this.$message.error(err.msg);
      }
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
